import * as React from 'react';
import * as Redux from 'redux';
import DatePicker from 'react-datepicker';
import { toDate } from 'date-fns'

interface IDatePickerProps {
    name?: string;
    startDate?: string;
    endDate?: string;
    minDate?: string;
    maxDate?: string;
    customClasses?: string;
    id?: string;
    selectedDate?: any;
    placeHolder?: string;
}

interface IState {
    selectedDate: Date;
}

export class DatePickerComponent extends React.Component<IDatePickerProps, IState> {
    constructor(props) {
        super(props)
        this.state = {
            selectedDate: this.props.selectedDate && this.props.selectedDate.length > 0 ? new Date(this.props.selectedDate) : new Date ()
        };
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(date) {
        this.setState({
            selectedDate: date
        });
    }

    render() {

        return (
            <div>
                <DatePicker
                    placeholderText={this.props.placeHolder ? this.props.placeHolder : "Click to select a date"}
                    selected={this.state.selectedDate}
                    onChange={this.handleChange}
                    name={this.props.name}
                    className={this.props.customClasses}
                    id={this.props.id} />
            </div>
        )
    }
}
